<template>
  <div class="flex flex-row items-center gap-2">
    <CustomDropdown
      ref="dropdownRef"
      v-if="!disabled"
      maxHeight="300px"
      gap="10px"
      position="start"
      width="w-fit"
      dropdownCSS="p-0"
    >
      <template #trigger>
        <div class="secondary_small gap-1 !px-2">
          <ThemeImage
            class="size-4"
            :icon="imageNames.PANEL_PROJECT"
            alt="task_icon"
          />

          <span class="text_color text-[13px]">{{
            selectedProject?.name || "Select a project"
          }}</span>

          <ThemeImage
            class="size-4"
            :icon="imageNames.DROPDOWN_GREY"
            alt="dropdown_icon"
          />
        </div>
      </template>

      <template #default>
        <DropdownOptions
          :options="projectOptions"
          :selected-values="selectedProjectId ? [selectedProjectId] : []"
          show-search
          search-label="SELECT PROJECT"
          search-placeholder="Search projects"
          show-avatar
          :show-unselect-all="false"
          @select="handleProjectSelect"
        />
      </template>
    </CustomDropdown>

    <div
      v-else
      class="secondary_small gap-1 !px-2 cursor-not-allowed opacity-60"
    >
      <ThemeImage
        class="size-4"
        :icon="imageNames.PROJECT_GREY"
        alt="task_icon"
      />
      <span class="text_color text-[13px]">{{
        selectedProject?.name || "Select a project"
      }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import CustomDropdown from "@/src/components/CustomDropdown.vue";
import DropdownOptions from "@/src/components/common/DropdownOptions.vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  projects: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const dropdownRef = ref(null);
const selectedProject = ref(props.modelValue);

const projectOptions = computed(() => {
  return props.projects.map((project) => ({
    id: project.id,
    value: project.id,
    name: project.name,
    label: project.name,
    ...project,
  }));
});

const selectedProjectId = computed(() => {
  return selectedProject.value?.id || null;
});

const handleProjectSelect = (option) => {
  const project = props.projects.find((p) => p.id === option.id);
  if (project) {
    selectedProject.value = project;
    emit("update:modelValue", project);
  }
};

const openDropdown = () => {
  if (dropdownRef.value && !dropdownRef.value.isOpen) {
    dropdownRef.value.toggleDropdown();
  }
};

watch(
  () => props.modelValue,
  (newVal) => {
    selectedProject.value = newVal;
  },
);

defineExpose({
  openDropdown,
});
</script>
